import { z } from 'zod';

const allowNumberAndDash = (val: string) => /^[0-9-]+$/.test(val);
const removeDash = (val: string) => val.replace(/-/g, '');

export const optionalFixedDigits = (digits: number, notNumberMsg: string, digitMsg: string) =>
  z.preprocess(
    val => (typeof val === 'number' ? String(val) : val),
    z
      .string()
      .trim()
      .optional()
      .nullable()
      // check only number + dash
      .refine(val => !val || allowNumberAndDash(val), {
        message: notNumberMsg,
      })
      // check exact digit length (ignore dash)
      .refine(
        val => {
          if (!val) return true;
          const onlyDigits = removeDash(val);
          return new RegExp(`^[0-9]{${digits}}$`).test(onlyDigits);
        },
        { message: digitMsg }
      )
  );

export const optionalRangeDigits = (
  min: number,
  max: number,
  notNumberMsg: string,
  digitMsg: string
) =>
  z.preprocess(
    val => (typeof val === 'number' ? String(val) : val),
    z
      .string()
      .trim()
      .optional()
      .nullable()
      // check only number + dash
      .refine(val => !val || allowNumberAndDash(val), {
        message: notNumberMsg,
      })
      // check digit range (ignore dash)
      .refine(
        val => {
          if (!val) return true;
          const onlyDigits = removeDash(val);
          return new RegExp(`^[0-9]{${min},${max}}$`).test(onlyDigits);
        },
        { message: digitMsg }
      )
  );
